import { Route, Routes } from "react-router-dom";
import SectorsPage from "../../pages/shared-pages/sector/SectorsPage";
import NewSectorPage from "../../pages/shared-pages/sector/NewSectorPage";
import UpdateSectorPage from "../../pages/shared-pages/sector/UpdateSectorPage";
import SectorDetailsPage from "../../pages/shared-pages/sector/SectorDetailsPage";

export default function SectorNav() {
    return (
        <Routes>

            <Route path="/" element={<SectorsPage />} />
            <Route path="/new" element={<NewSectorPage />} />
            <Route path="/update" element={<UpdateSectorPage />} />
            <Route path="/details" element={<SectorDetailsPage />} />

        </Routes>
    )
}
